import ArtTypes from '~/constants/types/ArtTypes';
import UploadTypes from '~/constants/types/UploadTypes';
import TextTypes from '~/constants/types/TextTypes';
import SelectionTypes from '~/constants/types/SelectionTypes';
import {createAction} from 'redux-actions';
import {
  getSelectedIconIds,
  getSelectedIconsArray,
  selectedIcon,
  getIconFromCurrentDesign,
  getLastArtIconId,
  getLastTextIconId,
  getLastUploadIconId
} from '~/selectors/CanvasSelectors';

export const deselectIcon = createAction(SelectionTypes.DESELECT_ICON);

export const deselectAllIcons = createAction(SelectionTypes.DESELECT_ALL_ICONS);

export const selectAdditionalIcons = createAction(
  SelectionTypes.SELECT_ADDITIONAL_ICONS
);

export const selectIcons = createAction(SelectionTypes.SELECT_ICONS);

export const selectIcon =
  ({iconId, toggle}) =>
  (dispatch, getState) => {
    // Method returns the future select state of the icon, this is useful when
    // the following actions depends on whenever the icon will be selected or not
    if (toggle) {
      const state = getState();
      const isAlreadySelected = getSelectedIconIds(state).includes(iconId);

      if (isAlreadySelected) {
        dispatch(deselectIcon({iconId}));
      } else {
        dispatch(selectAdditionalIcons({iconId}));
        dispatch(updateLastSelectedIconByType({iconId}));
      }
    } else {
      dispatch({
        type: SelectionTypes.SELECT_ICON,
        payload: {iconId}
      });
      dispatch(updateLastSelectedIconByType({iconId}));
      const icon = selectedIcon(getState());
      if (icon?.categoryPath) {
        dispatch({
          type: ArtTypes.BROWSED_CATEGORIES,
          payload: icon.categoryPath.replace(/^[^/]+\//, '').split(/\/(?=\D)/)
        });
      }
    }
    return {
      nextSelectedIcons: getSelectedIconsArray(getState())
    };
  };

export const updateLastSelectedIconByType =
  ({iconId}) =>
  (dispatch, getState) => {
    const lastIcon = getIconFromCurrentDesign(getState())(iconId);

    switch (lastIcon?.type) {
      case 'UPLOAD': {
        dispatch({
          type: UploadTypes.UPDATE_LAST_UPLOAD,
          payload: {iconId: lastIcon?.id}
        });
        break;
      }
      case 'TEXT': {
        dispatch({
          type: TextTypes.UPDATE_LAST_TEXT,
          payload: {iconId: lastIcon?.id}
        });
        break;
      }
      case 'CLIPART': {
        dispatch({
          type: ArtTypes.UPDATE_LAST_ART,
          payload: {iconId: lastIcon?.id}
        });
        break;
      }
    }
  };

export const selectLastIconOfType =
  ({iconType}) =>
  (dispatch, getState) => {
    const state = getState();
    const lastArtIconId = getLastArtIconId(state);
    const lastTextIconId = getLastTextIconId(state);
    const lastUploadIconId = getLastUploadIconId(state);

    switch (iconType) {
      case 'UPLOAD': {
        if (
          !lastUploadIconId ||
          !getIconFromCurrentDesign(state)(lastUploadIconId)
        ) {
          return false;
        }
        dispatch(selectIcon({iconId: lastUploadIconId}));
        return true;
      }
      case 'TEXT': {
        if (
          !lastTextIconId ||
          !getIconFromCurrentDesign(state)(lastTextIconId)
        ) {
          return false;
        }
        dispatch(selectIcon({iconId: lastTextIconId}));
        return true;
      }
      case 'CLIPART': {
        if (!lastArtIconId || !getIconFromCurrentDesign(state)(lastArtIconId)) {
          return false;
        }
        dispatch(selectIcon({iconId: lastArtIconId}));
        return true;
      }
    }
    return false;
  };
